import ModulesLayout from './Modules.vue';
import { Modules } from './types';

export { Modules };
export default ModulesLayout;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/tabs/modules/index.ts